import React from "react"
import Img from "gatsby-image"
import { css } from "styled-components"

const Hero = ({ src }) => (
  <div
    css={css`
      width: 100%;
      padding-top: 50%;
      position: relative;
      margin-bottom: 20px;
    `}
  >
    <Img
      fluid={src}
      alt="cover"
      style={{
        position: "absolute",
      }}
      objectFit="cover"
      objectPosition="50% 50%"
      css={css`
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      `}
    />
  </div>
)

export default Hero
